import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EstimationResult} from './estimation.result.model';
import {Estimation} from './estimation.model';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import {AuthService} from '../auth/auth.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstimationService {

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  estimate(estimations: Array<Estimation>): Observable<Array<EstimationResult>> {

    return this.httpClient.post<Array<EstimationResult>>(`${environment.baseUrl}/estimate`, estimations,
      {headers: this.authService.getHeaders()});
  }
}
